import {useState} from 'react'
import classnames from 'classnames'
import {List, Map} from 'immutable'
import PropTypes from 'prop-types'

import AddDeputyModal from '../corp_max_deputies/add/AddDeputyModal'
import ManagePermissions from '../corp_max_deputies/permissions/ManagePermissions'
import MixpanelLogger from '../../../../lib/MixpanelLogger'
import ModuleBox from '../../../../shared_components/component_templates/ModuleBox'
import {useOrganizationCobranding} from '../../../../shared_components/OrganizationCobrandingContext'
import SharingModuleWithDeputies from './with_deputies/SharingModuleWithDeputies'
import SharingModuleWithoutDeputies from './SharingModuleWithoutDeputies'
import {hasOrganizationCobranding} from '../../../../lib/cobrandingTools'
import {useDeputizerData, useDeputyData} from '../../../../lib/hooks'
import Logger from '../../../../lib/NewLogger'

import './sharingModuleController.scss'

const SharingModuleController = props => {
  const organizationCobranding = useOrganizationCobranding()

  const [showAddDeputyModal, setShowAddDeputyModal] = useState(false)
  const [showDeputyPermissionsModal, setShowDeputyPermissionsModal] = useState(false)
  const [manageDeputyOwnershipId, setManageDeputyOwnershipId] = useState()

  const everplanId = props.userConfig.get('everplan-id')

  const {deputies} = useDeputyData(everplanId)
  const {deputizers} = useDeputizerData(props.userConfig)

  const toggleDeputyPermissionsModal = deputyId => {
    setShowDeputyPermissionsModal(prevShowDeputyPermissionsModal => !prevShowDeputyPermissionsModal)
    setManageDeputyOwnershipId(deputyId)
  }

  const openAddDeputyModal = () => {
    MixpanelLogger.track('click_add_deputy', {
      context: 'sharing_module',
      deputy_count: deputies.size,
      source: 'planholder'
    })

    Logger.log({
      name: 'clicked_add_new_deputy',
      payload: {context: props.context}
    })

    setShowAddDeputyModal(true)
  }

  return (
    <div className='sharing-module-controller'>
      <ModuleBox
        className={classnames(
          'module-box',
          {'with-everplans-custom-colors': !hasOrganizationCobranding(
            organizationCobranding
          )}
        )}>
        {
          deputies.isEmpty() && deputizers.isEmpty() ?
            <SharingModuleWithoutDeputies context={props.context} /> :
            <SharingModuleWithDeputies
              deputizers={deputizers}
              deputies={deputies}
              openAddDeputyModal={openAddDeputyModal}
              toggleDeputyPermissionsModal={toggleDeputyPermissionsModal}
            />
        }
        {
          showAddDeputyModal && (
            <AddDeputyModal
              {...props}
              deputies={deputies}
              exit={() => setShowAddDeputyModal(false)}
              mixpanelContext='sharing_module'
            />
          )
        }
        {
          showDeputyPermissionsModal && (
            <ManagePermissions
              {...props}
              exit={toggleDeputyPermissionsModal}
              deputies={deputies}
              deputyOwnershipId={manageDeputyOwnershipId}
            />
          )
        }
      </ModuleBox>
    </div>
  )
}

SharingModuleController.propTypes = {
  context: PropTypes.string.isRequired,
  itemResponses: PropTypes.instanceOf(List),
  userConfig: PropTypes.instanceOf(Map)
}

export default SharingModuleController
